export default {
  "home": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hi there!✨"])},
    "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["How can we help you today? We are here for you, so let's start a conversation!"])}
  },
  "conversation": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Current conversations"])},
    "last_message_empty_caption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New conversation..."])},
    "welcome_text": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Hello! Welcome to ", _interpolate(_named("messengerName")), "."])},
    "enter_message_info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please enter your question below so we can answer your question swiftly."])},
    "compose": {
      "input_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Write a message..."])}
    },
    "survey": {
      "post": {
        "body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["We'd love to hear what you think of this conversation:"])},
        "thank_you_msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Thanks for your feedback! This will help us improve our service for you and others."])}
      }
    },
    "status": {
      "sending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sending..."])},
      "sent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sent"])},
      "conversation_is_closed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conversation is closed"])}
    },
    "errors": {
      "404": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conversation could not be loaded!"])}
    }
  },
  "archived_conversations": {
    "header": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Archived Conversations (", _interpolate(_named("count")), ")"])}
  },
  "search": {
    "input_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search for help articles"])},
    "no_results": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["No results for \"", _interpolate(_named("query")), "\""])},
    "no_results_hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please try a different keyword"])}
  },
  "channels": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["How would you like to get in touch today?"])},
    "whatsapp": {
      "card_header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send a WhatsApp message"])},
      "qr_code_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scan with your camera app or click the QR code to start a conversation."])},
      "button_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Open WhatsApp"])},
      "number_undefined_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Number is undefined."])},
      "initial_text_msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hi team! I was wondering..."])}
    }
  },
  "agents": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "availability": {
      "online": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Our support team is online"])},
      "offline": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
    },
    "status": {
      "online": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Online"])},
      "offline": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Offline"])},
      "away": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Away"])}
    },
    "is_typing": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("agentName")), " is typing..."])}
  },
  "forms": {
    "fields": {
      "_CONTACT_NAME": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "_CONTACT_EMAIL": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["firstname", "@", "company.com..."])}
      },
      "_CONTACT_PHONE": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Phone"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(i.e. 0612345678)"])}
      },
      "_SUBJECT": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Subject"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "_INITIAL_MESSAGE": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Question"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "_MESSAGE": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Message"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      }
    },
    "types": {
      "PRE_CHAT": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fill out the form below, so that we can get to know you 😄"])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send your message"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["We'll set you up with one of our team members!"])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oops, the conversation could not be started. Can you try again?"])}
      },
      "CONTACT_DETAILS": {
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fill out the form below, so that we can stay in contact"])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Submit"])},
        "dismiss-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Not now"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Thank you for providing your email address."])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oops, the form could not be submitted"])}
      },
      "EMAIL": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Drop us a line"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fill out the form below to get in touch with our customer support team"])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send your message"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The email form has been sent!"])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oops, the email could not be delivered. Please try again."])}
      },
      "WHATSAPP_CONTACT": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Start a WhatsApp conversation"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Introduce yourself and ask your question so we can help you straight away."])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send your message"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The WhatsApp contact form has been send!"])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oops, the WhatsApp contact form could not be submitted. Can you try again?"])}
      }
    }
  },
  "mailform": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email Form"])},
    "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fill out the form below to reach out to our customer support team"])},
    "fields": {
      "NAME": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "SUBJECT": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Subject"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "QUESTION": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Question"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "EMAIL": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "UPLOAD": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "add_btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add attachment"])}
      },
      "TOPIC": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Topic"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select..."])}
      }
    },
    "notifications": {
      "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The email form has been send!"])},
      "errors": {
        "default": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unfortunately the form cannot be sent. Can you try again?"])}
      }
    },
    "submit_btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send message"])}
  },
  "common": {
    "buttons": {
      "start_new_conversation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Let's start a conversation"])},
      "show_archived_conversations": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Show archived conversations (", _interpolate(_named("count")), ")"])},
      "go_to_mailform": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send an email instead"])},
      "go_back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back"])}
    },
    "page_title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["💬 New message \"", _interpolate(_named("message")), "\""])},
    "toast": {
      "generic_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oops, something went wrong!"])},
      "message_sent_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An error occurred while sending the message"])},
      "giphy_no_results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No Giphy image could be found."])}
    },
    "errors": {
      "upload_too_large": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The file size may not exceed 5MB"])},
      "upload_file_type_disallowed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This file type is not allowed"])}
    }
  },
  "gdpr": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["GDPR Cookie Consent"])},
    "body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hi there! We would love to talk to you. However, under the EU General Data Protection Regulation, we need your approval first for our use of personal information (e.g. your name and email address). Do you agree if:<br><br>1) We'll store your personal information so that we can pick up the conversation if we talk later;<br><br>2) We may send you emails to follow up on our conversation here;<br><br>3) We may send you emails about our upcoming services and promotions.<br>"])},
    "disapprove_body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["That's okay. You can view the terms and policy any time and consent to continue"])},
    "yes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yes, no problem"])},
    "no": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No, not today"])}
  },
  "powered_by": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Powered by Grasp"])}
}